import React from 'react';
import useGetSimulationCompanyQuery from './hooks/useGetSimulationCompanyQuery.js';
import SimulationCompanyForm from './SimulationCompanyForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import useGetSimulationCompanyDepartmentsQuery from './hooks/useGetSimulationCompanyDepartmentsQuery.js';
import { Loading } from '@fasstech/middle-design-system';

const SimulationCompany = ({ getMiddleText }) => {
  const { getSimulationCompany, loading: isLoadingGetSimulationCompany } =
    useGetSimulationCompanyQuery();

  const { getSimulationCompanyDepartments } = useGetSimulationCompanyDepartmentsQuery();

  if (isLoadingGetSimulationCompany) return <Loading />;

  return (
    <SimulationCompanyForm
      getMiddleText={getMiddleText}
      departments={getSimulationCompanyDepartments}
      company={getSimulationCompany}
    />
  );
};

export default withMiddleFeatures(SimulationCompany);
